import { render, staticRenderFns } from "./ManageShippingInfo.vue?vue&type=template&id=376ce2fc&"
import script from "./ManageShippingInfo.vue?vue&type=script&lang=ts&"
export * from "./ManageShippingInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ManageShippingInfo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports